export const EXTRA_SERVICE_ORDER_ACTION = {
    ORDER: 'ORDER',
    CHANGE: 'CHANGE',
    CANCEL: 'CANCEL',
} as const;
